import { Component } from '@angular/core';
import { ResponseManagementExportFailedNotificationModel } from '../models/response-management-export-failed-notification-model';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';
import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';

@Component({
  selector: 'cai-response-management-export-failed-notification',
  templateUrl: './response-management-export-failed-notification.component.html',
  styleUrls: ['./response-management-export-failed-notification.component.scss'],
  standalone: false,
})
@NotificationType('ResponseManagementExportFailedNotification')
export class ResponseManagementExportFailedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: ResponseManagementExportFailedNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const message = this.localizationService.instant('ResponseManagement::ExportFailedMessage');

    this.toasterService.error(message);
  }
}
